module.exports = __webpack_public_path__ + "static/media/Fondo4.4cf8b546.jpg";